/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { NgxSliderModule, Options } from 'ngx-slider-v2';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { SliderTranslationData } from '../../interfaces/slider-translation-data.interface';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    NgxSliderModule,
    ReactiveFormsModule,
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderComponent implements OnInit {
  @Input() value: string;
  @Input({ required: true }) min: number;
  @Input({ required: true }) max: number;
  @Input({ required: true }) control: UntypedFormControl;
  @Input() colorfulSlideBar: boolean;
  @Input() sliderData: SliderTranslationData;

  @Output() valueChanged = new EventEmitter();

  protected options: Options;

  ngOnInit(): void {
    const steps = [this.min - 1];

    for (let i = this.min; i <= this.max + 1; i++) {
      steps.push(i);
    }

    const stepsArray = steps.map((v) => ({ value: v, legend: undefined }));

    this.options = {
      showSelectionBarEnd: true,
      showTicks: true,
      showTicksValues: true,
      stepsArray,
      maxLimit: steps.length - 2,
    };
  }

  protected userChangeEnd() {
    this.valueChanged.emit();
  }
}
